<template>
  <div class="p-15">
    <el-dialog :title="'订单发货'" :visible.sync="dialogVisible" width="500px">
      <el-form :model="shippedForm" :rules="rules" label-width="auto">
        <el-form-item label="订单编号:" prop="sn">
          <el-input v-model.trim="shippedForm.sn" disabled maxlength="30"></el-input>
        </el-form-item>
        <el-form-item label="快递公司:" prop="expressCode">
          <el-select v-model.trim="shippedForm.expressCode" maxlength="30" placeholder="请选择快递公司">
            <el-option v-for="(item, index) in expressInfo" :key="index" :label="item" :value="index"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="快递单号:" prop="expressNumber">
          <el-input v-model.trim="shippedForm.expressNumber" maxlength="30"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetShippedForm">取 消</el-button>
        <el-button type="primary" @click="onSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <el-card>
      <el-form ref="ruleForm" :model="searchForm" inline>
        <el-form-item prop="content">
          <el-input placeholder="请输入关键词" v-model.trim="searchForm.content" clearable>
            <el-select v-model="searchForm.field" slot="prepend" placeholder="请选择" style="width: 120px">
              <el-option v-for="item in SEARCH_FIELD" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item prop="query.source">
          <el-select v-model="searchForm.query.source" placeholder="订单来源" style="width: 120px">
            <el-option v-for="item in ORDER_SOURCE.options()" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="query.combineStatus">
          <el-select v-model="searchForm.query.combineStatus" placeholder="订单状态" style="width: 120px">
            <el-option v-for="item in ORDER_STATUS.options()" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="date_range">
          <el-date-picker
            v-model="searchForm.date_range"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            range-separator="至"
            start-placeholder="下单开始时间"
            end-placeholder="下单结束时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="resetPagination" type="primary">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="handleExport(exportUrl, {type: ORDER_TYPE.entity})" type="primary">导出</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card class="m-t-20">
      <div slot="header" class="flex flex-cc flex-sb">
        <span>实物订单</span>
        <span>
         <div class="flex">
          <el-button @click="handleExport(downloadShippedTemplateUrl)" type="primary" style="margin-right:10px">下载发货模板</el-button>
          <uploader :target="importUrl" @success="success" accept=".xlsx">
            <el-button type="primary">批量发货</el-button>
          </uploader>
         </div>
        </span>
      </div>
      <el-table :data="table_data">
        <el-table-column label="订单编号/下单时间">
          <template slot-scope="{ row }">
            <div>
              <router-link :to="{ name: 'order-material-detail', query: { id: row.id } }">
                <el-link type="primary"> {{ row.sn }}</el-link>
              </router-link>
            </div>
            <div class="text-ellipsis">
              {{ row.createdAt }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="兑换礼品">
          <template slot-scope="{ row }">
            <div v-if="row.gift" class="text-ellipsis">
              {{ row.gift.code }} / x{{ row.quantity }} / {{ row.gift.title }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="消耗积分" prop="creditTotal" width="120px" align="center"></el-table-column>
        <el-table-column label="用户昵称/手机号码" width="200px" align="center">
          <template slot-scope="{ row }">
            <div>
              {{ row.nickname }}
            </div>
            <div>{{ numberEncryption(row.phoneNumber) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="订单状态" width="120px" align="center">
          <template slot-scope="{ row }">
            {{ ORDER_STATUS.filterValue(row.combineStatus) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120px" align="center">
          <template slot-scope="{ row }">
            <el-link
              type="primary"
              :disabled="row.shippingStatus !== ORDER_STATUS.unshipped"
              @click="showModalDeliverGoods(row)"
              >发货</el-link
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination :changed="changePage" :total="total" :pagination="searchForm.pagination" />
    </el-card>
  </div>
</template>

<script>
import { ORDER_SOURCE, ORDER_STATUS, SEARCH_FIELD, ORDER_TYPE} from '@/enums/order'
import { getEntityList, getExpressInfo, entityOrderShipped, downloadShippedTemplateUrl,importShippedUrl, exportUrl, Type as OrderType} from '@/api/order'
import { numberEncryption } from '@/helpers'

export default {
  name: 'material',
  data() {
    return {
      total: 0,
      table_data: [],
      searchForm: {
        content: undefined,
        field: 'sn',
        date_range: [],

        query: {
          source: undefined,
          combineStatus: undefined
        },
        pagination: {
          currentPage: 1,
          limit: 10
        },
        withRels: ['gift']
      },
      expressInfo: {},
      shippedForm: {
        sn: undefined,
        id: undefined,
        expressCode: undefined,
        expressNumber: undefined
      },
      dialogVisible: false,
      SEARCH_FIELD,
      ORDER_SOURCE,
      ORDER_STATUS,
      numberEncryption,
      rules: {
        expressCode: this.$formHelper.requiredRuleFactory('请选择物流公司'),
        expressNumber: this.$formHelper.requiredRuleFactory('请输入物流单号')
      },
      downloadShippedTemplateUrl: '',
      importUrl:'',
      exportUrl,
      ORDER_TYPE
    }
  },
  methods: {
    resetPagination() {
      this.searchForm.pagination = { currentPage: 1, limit: 10 }
      this.init()
    },
    changePage(page) {
      this.searchForm = Object.assign(this.searchForm, page)
      this.init()
    },
    async init() {
      const { collection, meta } = await getEntityList(this.searchForm)
      this.table_data = collection
      this.total = meta.total
    },
    async getExpressInfo() {
      this.expressInfo = await getExpressInfo()
    },
    reset() {
      this.$refs.ruleForm.resetFields()
      this.init()
    },
    showModalDeliverGoods(record) {
      const { sn, id } = record
      this.shippedForm.sn = sn
      this.shippedForm.id = id
      this.dialogVisible = true
    },
    async onSubmit() {
      if (!this.shippedForm.expressCode || !this.shippedForm.expressNumber) {
        return
      }
      try {
        const result = await entityOrderShipped(this.shippedForm)
        this.$message.success('发货成功')
      } catch {
        this.$message.error('发货失败')
      }
      this.resetShippedForm()
      this.init()
    },
    resetShippedForm() {
      this.shippedForm = {}
      this.dialogVisible = false
    },
    success(res) {
      this.$notify({
        title: '导入结果',
        dangerouslyUseHTMLString: true,
        duration: 0,
        message: `成功:${res.success||0}条;<br>失败:${res.fail||0}条;`
      });
      this.init()
    },
  },
  mounted() {
    this.init()
    this.getExpressInfo()
    this.downloadShippedTemplateUrl = downloadShippedTemplateUrl
    this.importUrl = importShippedUrl 
  }
}
</script>

<style scoped>
</style>
